/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-10-13T17:19:55.636
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentSerComplaintFollowupEditInit,
	getRentSerComplaintFollowupView
} from '@api/rentmanage/RentSerComplaintFollowup';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},

	actions: {
		getRentSerComplaintFollowupEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentSerComplaintFollowupEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentSerComplaintFollowupView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentSerComplaintFollowupView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
